// Home page text
export const HOME_TEXT = "home";
export const ORDER_ID_PREFIX = "TG-";

export const USER_TOKEN_KEY_NAME = "token";
export const USER_STORAGE_KEY_NAME = "user";
export const USER_CART = "cart";
export const ADD_TO_CART = "ADD TO CART";
export const CATEGORIES_TEXT = "Categories";
export const ITEM_ADDED_TO_CART_MESSAGE =
  "Your cart has been updated successfully!";
// "Your product has been successfully added to the cart!";
export const ITEM_REMOVED_FROM_CART_MESSAGE =
  "Your product has been successfully removed from the cart!";
export const PRODUCT_SORT_DATA = [
  { label: "Recently Added", value: "recentlyAdded" },
  { label: "Best selling", value: "bestSeller" },
  { label: "Top rated", value: "topRated" },
  { label: "Price: High to Low", value: "highToLow" },
  { label: "Price: Low to High", value: "lowToHigh" },
];
export const PRODUCT_LISTING_SORT_DATA = [
  { label: "Featured Deals", value: "featuredDeals" },
  { label: "Recently Added", value: "recentlyAdded" },
  { label: "Price: High to Low", value: "highToLow" },
  { label: "Price: Low to High", value: "lowToHigh" },
];
export const SUBMIT_BUTTON = "Submit";
export const SELECT_SORT_BY = "Select sort by";
export const LOGIN_BUTTON = "Login";
export const LOGIN_WARNING = "You must be logged in to submit a review.";
export const SEARCH_PRODUCTS_TEXT = "Search Products";
export const RESULT_TEXT = "results";
export const ALL_COLLECTIONS = "All Collections";
export const SUBSCRIBE = "SUBSCRIBE";
export const COPYRIGHT = `Copyright © ${new Date().getFullYear()} TheGlobe Group Limited. All rights reserved.`;

export const PROFILE_UPDATE_SUCCESS_MESSAGE =
  "Your profile has been successfully updated.";
export const UPDATE_PROFILE_BUTTON_TITLE = "Update Profile";
export const SAVE_BUTTON = "SAVE";
export const TERM_AND_PRIVACY =
  "Kindly check the box to agree to the Terms & Conditions.";

// Reviews static text
export const REVIEW_TITLE = "Reviews";
export const REVIEW_SUBTITLE = "Write a review";
export const REVIEW_PLACEHOLDER = "Write a review here...";
export const WRITE_REVIEW_TITLE = "Leave a review";
export const SEE_REVIEW = "See Reviews";
export const RATING_TITLE = "Rating";
export const REVIEW_SUBMITED_MESSAGE =
  "Thank you for your review! It will be published soon.";
export const PRODUCT_REVIEW = "Write Product Review";
export const SELLER_REVIEW = "Write Seller Review";

// Vendor/Store page
export const VENDOR_PAGE_TITLE = "Our Vendors";
export const VENDOR_TITLE = "Vendors";
export const SALES = "Sales";

// Store Products/Details page
export const CONTACT_VENDOR = "Contact shop owner";
export const FEATURED_ITEMS = "Featured items";
export const TAB_HEADINGS = [
  { target: "items", title: "Items" },
  { target: "reviews", title: "Reviews" },
  { target: "about", title: "About" },
  { target: "shopPolicies", title: "Shop Policies" },
];
export const SORT_BY_TEXT = "Sort by";
export const SHOP_POLICY = "Shop Policies";

// New letter section
export const NEWS_LETTER_TITLE =
  'Get the Best<span style="color: #FFC107;"> NZ Classifieds Deals </span>first';

export const NEWS_LETTER_SUBTITLE =
  "Be the first to know about new listings, second hand items, and limited-time deals across NewZealand. Subscribe and stay connected to your Kiwi online marketplace.";
export const NEWS_LETTER_SUCCESS =
  "Thank you for subscribing! You'll now receive exclusive deals and updates.";

// Form constants
export const EMAIL_PLACEHOLDER = "Email address";
export const NAME_PLACEHOLDER = "Your name";
export const PASSWORD_NOT_MATCH = "Passwords do not match.";
export const LABEL_FIRST_NAME = "First Name";
export const LABEL_LAST_NAME = "Last Name";
export const LABEL_EMAIL = "Email";
export const LABEL_PHONE = "Phone";
export const LABEL_ADDRESS = "Address";
export const LABEL_PIN = "PIN Code";
export const FIRST_NAME_PLACEHOLDER = "Enter first name";
export const LAST_NAME_PLACEHOLDER = "Enter last name";
export const PHONE_NUMBER_PLACEHOLDER = "Enter phone number";

export const BILLING_DETIAL = "Billing Address";
export const DELIVERY_DETAIL = "Delivery Address";

// Account Page
export const ACCOUNT_PAGE_TITLE = "Your Account";
export const DATA_OPTIONS = [
  {
    title: "Profile",
    slug: "/user/profile",
  },
  {
    title: "Orders",
    slug: "/user/orders",
  },
  {
    title: "Manage Addresses",
    slug: "/user/manage-address",
  },
  {
    title: "My Favorites",
    slug: "/user/favorites",
  },
  {
    title: "My Open Homes",
    slug: "/user/open-homes",
  },
  {
    title: "My Listing",
    slug: "/user/product-listing",
  },
  {
    title: "My Products",
    slug: "/user/my-products",
  },
  {
    title: "Viewing Requests",
    slug: "/user/arrange-viewing-requests",
  }
];

// Profile Page
export const PROFILE_PAGE_TITLE = "Your Profile";

// Change password
export const CHANGE_PASSWORD_TITLE = "Change Password";

// Registration page
export const REGISTRATION_PAGE_TITLE = "Create new account";
export const CREATE_NEW_ACCOUNT = "Create new account";
export const REGISTRATION_PAGE_SUBTITLE =
  "Welcome to TheGlobe Get ready to enjoy a seamless shopping experience. Sign up in just a few steps and unlock access to exclusive deals, personalized recommendations, and faster checkout!";
export const REGISTRATION_PAGE_FORM_TITLE = "Enter Personal Details";
export const CREATE_ACCOUNT = "Create Account";
export const HAVE_ACCOUNT_TEXT = "Already have an account?";
export const LOGIN_HERE_TEXT = "Login here?";
export const REGISTRATION_SUCCESS = "Registration successful, Welcome aboard!";

// Orders listing/Order Items listing page
export const ORDERS_LISTING_PAGE_TITLE = "Your Orders";
export const TH_ORDER_ID = "Order ID";
export const TH_ORDER_PLACED = "Order Placed At";
export const TH_ORDER_STATUS = "Order Status";
export const TH_ORDER_ITEMS = "Order Items";
export const TH_TOTAL_AMOUNT = "Total Amount";
export const TH_TAX_AMOUNT = "Tax Amount";
export const TH_PAYMENT_STATUS = "Payment Status";
export const TH_QUICK_ACTIONS = "Quick Actions ";
export const VIEW_DETAILS = "View All";

export const ORDER_ITEMS_PAGE_TITLE = "Order Items";
export const BACK_BUTTON_TITLE = "All Orders";
export const TH_PRODUCT_NAME = "Product Name";
export const TH_MEDIA = "Media";
export const TH_QUANTITY = "Quantity";
export const TH_PRICE = "Price";
export const TH_SHIPPING_DETAILS = "Shipping Details";

// Checkout page
export const CHECKOUT_PAGE_BILLING_TITLE = "Billing address";
export const SAME_ADDRESS = "The same applies to the shipping address";
export const CHECKOUT_PAGE_SHIPPING_TITLE = "Shipping address";
export const SELECT_COUNTRY = "Select country";
export const SELECT_STATE = "Select state";
export const TOWN_CITY = "Town/City";
export const ADDRESS_TYPE = "Address type";

export const CARDS_LIST = ["visa", "amex", "paypal", "discover", "mastercard"];

export const HOME_PAGE_MENU = [
  {
    title: "Home",
    image: "homeIcon",
    link: "/",
  },
  {
    title: "Marketplace",
    image: "marketIcon",
    link: "/marketplace",
  },
  {
    title: "Motors",
    image: "motorIcon",
    link: "/l/category/motors",
  },
  {
    title: "Jobs",
    image: "jobIcon",
    link: "/l/category/jobs/all",
  },
  {
    title: "Property",
    image: "propertyIcon",
    link: "/l/category/property",
  },
  {
    title: "Service",
    image: "serviceIcon",
    link: "/l/category/service",
  },
];

export const MEGA_MENU_STATIC = [
  {
    menu_title: "Property Options",
    menu_list: [
      {
        title: "Residential",
        link: "/",
      },
      {
        title: "New homes",
        link: "/",
      },
      {
        title: "Sold",
        link: "/",
      },
      {
        title: "Retirement villages",
        link: "/",
      },
    ],
  },
  {
    menu_title: "More Options",
    menu_list: [
      {
        title: "Flatmates",
        link: "/",
      },
      {
        title: "Commercial",
        link: "/",
      },
      {
        title: "Rural",
        link: "/",
      },
      {
        title: "Businesses",
        link: "/",
      },
    ],
  },
  {
    menu_title: "Thinking of selling?",
    menu_list: [
      {
        title: "Request an Appraisal",
        link: "/",
      },
      {
        title: "Find an Agent",
        link: "/",
      },
      {
        title: "Research sold properties",
        link: "/",
      },
      {
        title: "News & Selling guides",
        link: "/",
      },
    ],
  },
  {
    menu_title: "Tools",
    menu_list: [
      {
        title: "Buyers guides",
        link: "/",
      },
      {
        title: "Renters guides",
        link: "/",
      },
      {
        title: "Sold properties",
        link: "/",
      },
      {
        title: "International property",
        link: "/",
      },
    ],
  },
];

export const PAYMENT_FAIL_MESSAGE =
  "Unfortunately, your payment was not successful. Please try again or use a different payment method. If the issue persists, contact our support team for assistance.";

// TheGlobe DETAILS
export const FACEBOOK_lINK =
  "https://www.facebook.com/share/1BmqRxd78W";
export const INSTAGRAM_LINK = "https://www.instagram.com/theglobe_marketplace_";
export const TWITTER_LINK = "https://x.com/infotheglobe/status/1943282339976745248?s=46https://x.com/InfoTheglobe";
export const YOUTUBE_LINK = "https://www.youtube.com/@theglobe.site.official";
export const STORE_DESCRIPTION =
  "Introducing TheGlobe 100* kiwi - owned Business. Its New Zealand's newest and most innovative shopping app designed to redefine the way Kiwis shop online. With a user-friendly interface, exclusive local deals, and a vast selection of products from top retailers, TheGlobe offers a seamless shopping experience that caters to all your needs. Whether you're looking for the latest fashion, electronics, car accessories, handed - down car parts, beauty and skincare , supplements, or unique local goods, our app connects you to everything you need in one place.";
export const STORE_ADDRESS = "";
export const STORE_ADDRESS_HOME = {
  street: "",
  origin: "",
  country: "",
};
export const STORE_EMAIL = "info@theglobe.nz";
export const STORE_PHONE = "";
export const MAIN_CATEGORIES=[
  "motors",
  "jobs",
  "property",
  "services",
  "service"
]
export const formatPhoneNumber = (contact: string) => {
  if (!contact) return "";

  // Match possible phone numbers (with +, spaces, dashes, or slashes)
  const phoneRegex = /(\+?\d[\d\s\-\/]{6,}\d)/g;

  return contact.replace(phoneRegex, (rawNumber) => {
    let cleaned = rawNumber.replace(/[\s\-\/]/g, ""); // remove spaces, dashes, slashes

    // Fix numbers
    if (cleaned.startsWith("+640")) {
      cleaned = "+64" + cleaned.slice(4); // remove extra zero
    } else if (cleaned.startsWith("0")) {
      cleaned = "+64" + cleaned.slice(1); // local -> intl
    } else if (!cleaned.startsWith("+64")) {
      // fallback: if it’s just digits without prefix
      cleaned = "+64" + cleaned;
    }

    return cleaned;
  });
}